import { flashTicker, newsFlash } from "@/mocks/home";

export default function NewsFlashRail() {
  return (
    <section id="flash" className="w-full border-y border-background-200 bg-background-100">
      <div className="overflow-hidden border-b border-background-200 bg-primary-950">
        <div className="flex w-max animate-ticker py-2.5">
          {[0, 1].map((dup) => (
            <div key={dup} className="flex items-center shrink-0">
              {flashTicker.map((text, i) => (
                <span key={`${dup}-${i}`} className="flex items-center text-xs font-label text-background-100 whitespace-nowrap">
                  <i className="ri-flashlight-fill text-accent-400 mx-4" />
                  {text}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-[1360px] mx-auto px-4 md:px-8 py-9 md:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-3">
            <span className="text-[11px] font-label tracking-[0.24em] text-secondary-600">LIVE FEED</span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-black text-foreground-950">快讯流</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-500">
              按分钟记录事件的每一次公开动作，只保留可被公开检索到的信息，方便你随时回看事件是如何一步步发酵的。
            </p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-full bg-secondary-100 text-secondary-900 px-3 py-1.5 text-[11px] font-label">
              <span className="w-1.5 h-1.5 rounded-full bg-secondary-500 animate-pulse-dot" />
              今日已更新 8 条
            </div>
          </div>

          <div className="lg:col-span-9">
            <ul className="divide-y divide-background-200 border-t border-background-200">
              {newsFlash.map((item) => (
                <li
                  key={item.time}
                  className="group flex items-start gap-4 md:gap-6 py-3.5 md:py-4 hover:bg-background-50 transition-colors"
                >
                  <span className="w-14 md:w-16 shrink-0 font-heading text-sm md:text-base font-bold text-primary-600 tabular-nums pt-0.5">
                    {item.time}
                  </span>
                  <p className="flex-1 text-sm leading-relaxed text-foreground-700 group-hover:text-foreground-950 transition-colors">
                    {item.text}
                  </p>
                  <span className="hidden sm:inline-block shrink-0 rounded-full border border-secondary-200 bg-secondary-50 px-2.5 py-0.5 text-[11px] font-label text-secondary-800 whitespace-nowrap">
                    {item.tag}
                  </span>
                </li>
              ))}
            </ul>
            <button
              type="button"
              className="mt-6 inline-flex items-center gap-2 rounded-md border border-foreground-950 px-5 h-10 text-sm font-label text-foreground-950 hover:bg-foreground-950 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部快讯
              <i className="ri-arrow-right-up-line" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}